import { IComponentOptions } from "angular";
import { AmendmentsViewController } from "./controller";

export const vsComponentName = "contractAmendmentsComponent";

export const contractAmendmentsComponentOptions: IComponentOptions = {
  controller: AmendmentsViewController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    amendments: "<",
    amendmentId: "<?",
    apiUrl: "@",  
    title: "@?",      
  },
};